import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { useState } from "react";

import useDesktopChecker from "hooks/useDesktopChecker";

import BannerCard from "components/v2/banner-card/BannerCard";
import NativeAppPromoModal, {
  useNativeAppPromoState,
} from "components/v2/native-app-promo-modal/NativeAppPromoModal";

import {
  NATIVE_APP_BANNER_GET_APP_LABEL,
  NATIVE_APP_BANNER_SCAN_QR_LABEL,
  NATIVE_APP_BANNER_SUBTITLE,
  NATIVE_APP_BANNER_TITLE,
  NATIVE_APP_PROMO_APP_STORE_URL,
  NATIVE_APP_PROMO_GOOGLE_PLAY_URL,
} from "utilities/Constant";
import {
  NativeAppFullStoryProps,
  trackFSNativeAppBannerClicked,
  trackFSNativeAppBannerDismissed,
} from "utilities/full-story";

interface NativeAppBannerCardProps {
  readonly onDismiss?: () => void;
  readonly className?: string;
  readonly isModalOpenByDefault?: boolean;
  readonly variant?: "desktop" | "mobile";
  readonly trackingProps?: NativeAppFullStoryProps;
}

export default function NativeAppBannerCard({
  onDismiss,
  className,
  isModalOpenByDefault = false,
  variant,
  trackingProps,
}: NativeAppBannerCardProps) {
  const hookIsDesktop = useDesktopChecker();
  const isDesktop = variant ? variant === "desktop" : hookIsDesktop;
  const [isModalOpen, setIsModalOpen] = useState(isModalOpenByDefault);
  const { isQrOk, onQrError, shouldShowBadges, onBadgeError } = useNativeAppPromoState();

  const ctaLabel = isDesktop
    ? NATIVE_APP_BANNER_SCAN_QR_LABEL
    : NATIVE_APP_BANNER_GET_APP_LABEL;

  const handleCtaClick = () => {
    if (ctaLabel === NATIVE_APP_BANNER_SCAN_QR_LABEL) {
      setIsModalOpen(true);
      return;
    }

    const isAndroid = /android/i.test(navigator.userAgent);

    window.open(
      isAndroid
        ? NATIVE_APP_PROMO_GOOGLE_PLAY_URL
        : NATIVE_APP_PROMO_APP_STORE_URL,
      "_blank",
    );
  };

  return (
    <>
      <BannerCard
        title={NATIVE_APP_BANNER_TITLE}
        subtitle={NATIVE_APP_BANNER_SUBTITLE}
        ctaLabel={ctaLabel}
        onCTAClick={() => {
          trackFSNativeAppBannerClicked(trackingProps);
          handleCtaClick();
        }}
        onDismiss={() => {
          trackFSNativeAppBannerDismissed(trackingProps);
          onDismiss?.();
        }}
        icon={solid("mobile-alt")}
        variant={variant}
        className={className}
      />

      {isModalOpen && (
        <NativeAppPromoModal
          onClose={() => setIsModalOpen(false)}
          showQr={isQrOk}
          onQrError={onQrError}
          onBadgeError={onBadgeError}
          showAppStoreBadge={shouldShowBadges.appStore}
          showGooglePlayBadge={shouldShowBadges.googlePlay}
          trackingProps={trackingProps}
        />
      )}
    </>
  );
}
